import React, { useEffect, useRef } from "react";
import { ICONS, SUB } from "../dimIcons";

export default function DrillOptionsCard({
  anchorRef,            
  rowLabel,             
  options = [],         
  onSelect,             
  onClose               
}) {
  const cardRef = useRef(null);

  // close on click outside / Esc
  useEffect(() => {
    const onDoc = (e) => {
      if (!cardRef.current) return;
      if (
        !cardRef.current.contains(e.target) &&
        !anchorRef.current?.contains?.(e.target)
      ) onClose();
    };
    const onEsc = (e) => e.key === "Escape" && onClose();
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onEsc);
    };
  }, [onClose, anchorRef]);

  return (
    <div className="drill-card" ref={cardRef} role="dialog" aria-modal="true">
      <div className="drill-card-notch" />
      <div className="drill-card-head">
        <div className="title">Drill down “{rowLabel}”</div>
        <div className="sub">Choose the next dimension to explore</div>
      </div>

   <div className="drill-card-list">
       {options.map((opt) => {
         // prefer a supplied React component, else map by key, else fallback to className
         const IconComp = opt.iconComp || ICONS[opt.key];
         const sub = opt.sub || SUB[opt.key] || "";
         return (
           <button
             key={opt.key}
             className="drill-item"
             onClick={() => onSelect(opt.key)}
           >
             <div className="drill-ico">
               {IconComp ? (
                 <IconComp className="drill-feather" size={18} strokeWidth={2} />
               ) : (
                 <i className={opt.icon || "ri-grid-line"} />
               )}
             </div>
             <div className="drill-copy">
               <div className="drill-title">{opt.label}</div>
               <div className="drill-sub">{sub}</div>
             </div>
             <i className="ri-arrow-right-s-line drill-chevron" />
           </button>
         );
       })}
      </div>
    </div>
  );
}
